export function getSortedColumns(columns) {
  return Object.values(columns).sort((a, b) => {
    return a.index < b.index ? -1 : 1
  })
}

export function getVisibleColumns(columns) {
  return columns.filter(column => column.visible)
}

export function getOptionalColumns(columns, requiredColumns) {
  return columns.filter(column => !requiredColumns.includes(column.name))
}

export function isAllChecked(columns, requiredColumns) {
  const optionalColumns = getOptionalColumns(columns, requiredColumns)
  const visibleColumns = getVisibleColumns(optionalColumns)

  const visibleColumnsLength = visibleColumns.length
  const optionalColumnsLength = optionalColumns.length

  return (
    visibleColumnsLength > 0 &&
    optionalColumnsLength > 0 &&
    visibleColumnsLength === optionalColumnsLength
  )
}

export function hasSelected(columns, requiredColumns) {
  const optionalColumns = getOptionalColumns(columns, requiredColumns)
  const visibleColumns = getVisibleColumns(optionalColumns)

  const visibleColumnsLength = visibleColumns.length
  const optionalColumnsLength = optionalColumns.length

  return (
    visibleColumnsLength > 0 &&
    optionalColumnsLength > 0 &&
    visibleColumnsLength !== optionalColumnsLength
  )
}
